var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.25H73.2327V72.2327H2.25V1.25Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.74745V3.74745H0V0Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.6396H3.74745V74.387H0V70.6396Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.3198H3.74745V39.0673H0V35.3198Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7881 0H39.5356V3.74745H35.7881V0Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7881 70.6396H39.5356V74.387H35.7881V70.6396Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5763 0H75.3237V3.74745H71.5763V0Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5763 70.6396H75.3237V74.387H71.5763V70.6396Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5763 35.3198H75.3237V39.0673H71.5763V35.3198Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.251 10.0001L60.251 54.829L45.7764 54.829L45.7764 42.1345L29.6155 42.1345L29.6155 49.4421C29.6155 57.5137 23.0721 64.0571 15.0005 64.0571L15.0005 17.2139L29.6155 17.2139L29.6155 29.9553L45.7764 29.9553L45.7764 24.4746C45.7764 16.4806 52.2569 10.0001 60.251 10.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logo white.0b24c019087c3384482b29f157d053d7.svg";
export { ForwardRef as ReactComponent };